import React, { useCallback } from "react";
import { StatusEnum } from "../../hoc/with-status";
import { PIC } from "./pic";
import { useNavigator } from "../../hooks/use-navigator";
import { useParams } from "react-router-dom";
import * as adobeAnalytics from "../../utility/adobe-analytics";
import { isDragonstone } from "../../helpers/url-params";

export interface PICTaskProps {
  status: StatusEnum;
  href: string;
}

export const PICTask = ({ status, href }: PICTaskProps) => {
  const { applicationId, requisitionId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();

  const trackPicLinkClick = useCallback(() => {
    adobeAnalytics.addPageLoadMetric(
      window,
      applicationId,
      "ash click personal information",
      {
        jobId: requisitionId,
        isDragonstone: isDragonstone(requisitionId),
      }
    );
  }, [applicationId, requisitionId]);

  const [navigateToUrl] = useNavigator(href);

  const navigateToPic = useCallback(() => {
    trackPicLinkClick();
    navigateToUrl();
  }, [trackPicLinkClick, navigateToUrl]);

  const buttonRemove =
    status === StatusEnum.API_ERROR ||
    status === StatusEnum.COMPLETED ||
    status === StatusEnum.INELIGIBLE;
  return (
    <PIC
      status={status}
      navigateToUrl={navigateToPic}
      buttonRemove={buttonRemove}
    />
  );
};
